import { AuthService, CallbackComponent } from "@edpc/edp-auth";
import { Component, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Component({
    selector: "app-callback",
    template: ``,
})
export class EdpCallbackComponent extends CallbackComponent {
    constructor(auth: AuthService, router: Router, ngZone: NgZone, protected cookieService: CookieService) {
        super(auth, router, ngZone);
        if (!!router.routerState.snapshot.root.queryParams.is_impersonate) {
            const now = new Date();
            now.setTime(now.getTime() + 1 * 3600 * 1000 * 24);
            this.cookieService.set("is_impersonate", "true", now, "/");
        }
    }
}
